export interface EncodeOptions {
  types?: (
    | 'country'
    | 'region'
    | 'district'
    | 'postcode'
    | 'locality'
    | 'place'
    | 'neighborhood'
    | 'address'
    | 'poi'
  )[];
  limit?: number;
}

export interface GeocodeResult {
  id: string;
  type: string;
  place_type: string[];
  relevance: number;
  properties: Properties;
  text: string;
  place_name: string;
  bbox: number[];
  center: number[];
  geometry: Geometry;
  context: Context[];
}

interface Properties {
  mapbox_id: string;
  wikidata: string;
}

interface Geometry {
  type: string;
  coordinates: number[];
}

interface Context {
  id: string;
  mapbox_id: string;
  wikidata: string;
  text: string;
  short_code?: string;
}

class GeometryService {
  private baseURL: string;
  private params: URLSearchParams;

  constructor(mapboxToken: string) {
    this.baseURL = 'https://api.mapbox.com/geocoding/v5/';
    this.params = new URLSearchParams({
      access_token: mapboxToken,
      country: 'GB',
    });
  }

  async forwardGeocode(query: string, options: EncodeOptions) {
    const params = new URLSearchParams(this.params);
    if (options.types) params.append('types', options.types.join(','));
    if (options.limit) params.append('limit', options.limit.toString());

    const url = `${this.baseURL}mapbox.places/${encodeURIComponent(query)}.json?${params.toString()}`;

    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.json();
  }

  async reverseGeocode(longitude: number, latitude: number) {
    const params = new URLSearchParams(this.params);
    params.append('types', 'postcode');

    const url = `${this.baseURL}mapbox.places/${longitude},${latitude}.json?${params.toString()}`;
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.json();
  }
}

export { GeometryService };
